import Axios from 'axios';
// import { setupCache, buildWebStorage, buildKeyGenerator } from 'axios-cache-interceptor/dev';
import { setupCache, buildWebStorage, buildKeyGenerator } from 'axios-cache-interceptor';
const storage = localStorage;

const axiosInstance = setupCache(Axios.create({
    baseURL: '/api/',
    timeout: process.env.VUE_APP_HTTP_REQUEST_TIMEOUT,
}), {
    // maxAge:milliseconds, if be commented out, use the (cache-control:max-age * 1000) from the response header
    // maxAge: process.env.VUE_APP_HTTP_HEADERS_MAX_AGE_SECONDS * 1000,
    // storage: buildWebStorage(AxiosStorage.storage, 'hpc:'),
    storage: buildWebStorage(storage, 'hpc-' + process.env.NODE_ENV + ':'),
    // keyGenerator: buildKeyGenerator(({ url, method }) => ({
    //     method,
    //     url,
    //     custom: logicWith(method, url)
    // })),
    // debug: console.debug
})

axiosInstance.interceptors.request.use(function (cfg) {
    // cfg.cache['ttl'] = process.env.VUE_APP_HTTP_HEADERS_MAX_AGE_SECONDS;
    // console.debug('cfg', cfg)
    //cfg.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    cfg.headers['Accept'] = 'application/json';


    const authorizationToken = $cookies.get('authorizationToken');

    if (authorizationToken && authorizationToken['tokens']) {
        cfg.headers['Authorization'] = 'Bearer ' + authorizationToken.tokens.access_token;
    }

    // cfg.signal = AbortRequest.new().signal
    // console.debug('AbortRequest.new().signal',AbortRequest.new().signal)

    if (process.env.NODE_ENV !== 'production') {
        if (cfg.url.indexOf('_loop') === -1) {
            //console.debug('http request:[' + cfg.method + ']', cfg.url);
        }
    }

    return cfg;
})

axiosInstance.interceptors.response.use(function (response) {
    // console.debug("RESPONSE", response)
    return response;
}, function (error) {
    console.warn('http response error', error)
    switch (error['code']) {
        case "ERR_CANCELED":
        case "ECONNABORTED":
            break;
        default:
            switch (error.response.status) {
                case 401:
                    $cookies.remove("authorizationToken");
                    break;
                case 403:
                    error.response.data['message'] = "You do not have the permission to perform this action."
                    break;
            }
            break;
    }

    if (error.response.status == '503') {
        // console.debug("MAINTENENCE MODE")
        alert("Our website is currently undergoing updates. To prevent any access problem that you may encounter, please stop using the website at the moment. Thank you for your patience!");
        $cookies.remove("authorizationToken")
    }

    //return Promise.resolve, into [then]
    //return Promise.resolve(error.response);

    //return Promise.reject, into [catch]
    return Promise.reject(error)
})

class Http {

    static getAxiosInstance() {
        return axiosInstance;
    }

    static getStorage() {
        return storage;
    }

    static getCleanCacheConfig(id, url) {
        let cache = {
            update: {
            }
        }

        cache.update[id] = (listPostsCache, createPostResponse) => {
            let storage = localStorage;
            for (let i = 0; i < storage.length; i++) {
                let key = storage.key(i);
                if (key.indexOf(id) !== -1) {
                    storage.removeItem(key)
                    i--;
                }
            }

            return 'delete';
        };

        let cacheCfg = {
            id: id,
            generatorParams: {
                url: url
            },
            cache: cache
        };

        return cacheCfg;
    }

    static setCacheRequestConfig({
        id = '',
        cache = null,
        url = '',
        responseType = '',
    }, method = '') {
        let _cfg = {
        };

        if (responseType) {
            _cfg.responseType = responseType
        }

        //console.debug('id:', id, 'cache:', cache, 'url:', url, 'method:', method)

        if (id !== '' && responseType == 'json') {
            switch (method) {
                case 'post':
                case 'patch':
                case 'delete':
                    _cfg = {
                        ..._cfg,
                        ...Http.getCleanCacheConfig(id, url)
                    }
                    break;
                default:
                    let _cache = cache ? cache : {};

                    // let cacheId = id + buildKeyGenerator(({ url, method }) => ({
                    //     url,
                    //     method,
                    // }))(url, method);

                    let cacheId = id + ':' + url;
                    if (!_cache.ttl) {
                        _cache.ttl = process.env.VUE_APP_HTTP_HEADERS_MAX_AGE_SECONDS * 1000;
                    }

                    _cfg = {
                        ..._cfg,
                        id: cacheId,
                        cache: _cache,
                    };
                    break;
            }

            // console.debug('_cfg', _cfg)
        }
        return _cfg;
    }

    static head(url) {
        return axiosInstance.head(url);
    }

    static get(url, cacheRequestConfig = null) {
        cacheRequestConfig = Http.setCacheRequestConfig({ ...cacheRequestConfig, url: url }, 'get');
        // console.debug('cacheRequestConfig', cacheRequestConfig, url)
        return axiosInstance.get(url, cacheRequestConfig);
    }

    static post(url, data = null, cacheRequestConfig = null) {
        cacheRequestConfig = Http.setCacheRequestConfig({ ...cacheRequestConfig, url: url }, 'post');
        return axiosInstance.post(url, data, cacheRequestConfig);
    }

    static patch(url, data = null, cacheRequestConfig = null) {
        cacheRequestConfig = Http.setCacheRequestConfig({ ...cacheRequestConfig, url: url }, 'patch');
        return axiosInstance.patch(url, data, cacheRequestConfig);
    }

    static delete(url, cacheRequestConfig = null) {
        cacheRequestConfig = Http.setCacheRequestConfig({ ...cacheRequestConfig, url: url }, 'delete');
        return axiosInstance.delete(url, cacheRequestConfig);
    }
}

export default Http;